import styled from 'styled-components';

const CollapseWrapper = styled.div`
  padding: 0;
`;

export default CollapseWrapper;
